import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../core/common/modal/ModalComponent'
import { useActiveInactiveTeamsMutation, useDeactivateUserToggleMutation } from '../../../services/EndPointsApis'
import { all_routes } from '../../router/all_routes'

type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    refetch:any
    setCurrentToggleState:any
    handleDelete:any
}



const ActiveUserModal = ({ show,refetch, handleClose, data,setCurrentToggleState,handleDelete }: Props) => {
    const route = all_routes;
    const [deactivateUserToggle, { data: deActivedata, isError, error, isSuccess }] = useActiveInactiveTeamsMutation();
    const navigate = useNavigate();
    const initialValues =
        [
            {
                id: 0,
                isActive: true
            }
        ]
    const formik = useFormik({
        initialValues,
        onSubmit: (values, { resetForm }) => {

            deactivateUserToggle([
                {
                    id: data?.id,
                    isActive: data?.status === true ? false :true ,
                 }
            ])

        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(deActivedata?.message);
            handleClose();
            resetForm();
            handleDelete(data?.id)
            if(data.status===true){
                setCurrentToggleState(false);
            }
            else{
                setCurrentToggleState(true);
            }
            refetch();
        }
        
    }, [isSuccess]);
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);

    return (
        <ModalComponent
            buttonText=""
            modalTitle={data?.status!==true ?'Active Team':"Deactivate Team"}
            onClose={handleClose}
            onSave={formik.handleSubmit}
            isVisible={show}
            cancelButton="No"
            saveButton='Yes'
        >
            <>
                <p>
                    Are you sure you want to {data?.status !==true ?'Activate Team?':"Deactivate Team?"}</p>
            </>

        </ModalComponent>
    )
}

export default ActiveUserModal